import styled from 'styled-components';
import { Hollow } from 'components/Buttons';

const StyledHollow = styled(Hollow)`
${({ textColor }) => textColor && `color: ${textColor};`}
${({ borderColor, customColor }) => (borderColor || customColor) && `border: 1px solid ${borderColor || customColor};`}
  ${({
    customColor, hoverColor, borderColor, hoverColorText, hoverBorderColor,
  }) => (customColor || hoverColor
    ? `
      background-color: ${customColor};
      &:hover:not([disabled]) {
        border: 1px solid ${hoverBorderColor || hoverColor || `${customColor}aa`};
        background-color: ${hoverColor || (borderColor && `${borderColor}aa`) || `${customColor}aa`};
        ${hoverColorText ? `color: ${hoverColorText};` : ''}
      }
    `
    : ''
  )}
`;

export default StyledHollow;
